import cyfyDarkLogo from "assets/images/common/svgs/cyfy-dark-logo.svg";
import cyfyLightLogo from "assets/images/common/svgs/cyfy-logo.svg";

interface sharedReducerInitialState {
  isLoading: boolean;
  token: null | string;
  isDarkTheme: boolean | null;
  darkThemeLogo: any;
  lightThemeLogo: any;
  user: any;
  domain: string;
  permissions: string[];
  organization: any;
  unreadNotificationsCount: number;
  declaredResult: null | any;
}

const initialState: sharedReducerInitialState = {
  isLoading: false,
  token: null,
  isDarkTheme: false,
  lightThemeLogo: cyfyLightLogo,
  darkThemeLogo: cyfyDarkLogo,
  user: null,
  domain: window.location.hostname,
  permissions: [],
  organization: null,
  unreadNotificationsCount: 0,
  declaredResult: null,
};

export const SHARED_REDUCER_ACTIONS = {
  LOADING: "LOADING",
  SAVE_TOKEN: "SAVE_TOKEN",
  SAVE_USER: "SAVE_USER",
  SAVE_ORGANIZATION: "SAVE_ORGANIZATION",
  THEME_CHANGE: "THEME_CHANGE",
  LOGOUT: "LOGOUT",
  SAVE_PERMISSIONS: "SAVE_PERMISSIONS",
  HAS_USER_ALREADY_APPLIED: "HAS_USER_ALREADY_APPLIED",
  SAVE_LOGIN_AS_TOKEN: "SAVE_LOGIN_AS_TOKEN",
  SAVE_LOGIN_AS_USER: "SAVE_lOGIN_AS_USER",
  SAVE_LOGIN_AS_PERMISSIONS: "SAVE_lOGIN_AS_PERMISSIONS",
  LOGIN_AS_LOGOUT: "LOGIN_AS_LOGOUT",
  SAVE_UNREAD_NOTIFICATIONS_COUNT: "SAVE_UNREAD_NOTIFICATIONS_COUNT",
  SAVE_DECLARED_RESULT: "SAVE_DECLARED_RESULT",
};

const sharedReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case SHARED_REDUCER_ACTIONS.LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SHARED_REDUCER_ACTIONS.SAVE_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
    case SHARED_REDUCER_ACTIONS.SAVE_LOGIN_AS_TOKEN:
      return {
        ...state,
        loginAsToken: action.payload,
      };
    case SHARED_REDUCER_ACTIONS.THEME_CHANGE:
      return {
        ...state,
        isDarkTheme: action.payload,
      };
    case SHARED_REDUCER_ACTIONS.LOGOUT:
      return {
        ...state,
        token: null,
        isLoading: false,
        user: null,
        permissions: [],
        isDarkTheme: false,
        unreadNotificationsCount: 0,
        declaredResult: null,
      };
    case SHARED_REDUCER_ACTIONS.LOGIN_AS_LOGOUT:
      return {
        ...state,
        loginAsToken: null,
        isLoading: false,
        loginAsUser: null,
        loginAsPermissions: [],
        declaredResult: null,
      };
    case SHARED_REDUCER_ACTIONS.SAVE_USER:
      return {
        ...state,
        user: action.payload,
      };
    case SHARED_REDUCER_ACTIONS.SAVE_LOGIN_AS_USER:
      return {
        ...state,
        loginAsUser: action.payload,
      };
    case SHARED_REDUCER_ACTIONS.SAVE_PERMISSIONS:
      return {
        ...state,
        permissions: action.payload,
      };
    case SHARED_REDUCER_ACTIONS.SAVE_LOGIN_AS_PERMISSIONS:
      return {
        ...state,
        loginAsPermissions: action.payload,
      };
    case SHARED_REDUCER_ACTIONS.SAVE_ORGANIZATION:
      return {
        ...state,
        organization: action.payload,
      };
    case SHARED_REDUCER_ACTIONS.HAS_USER_ALREADY_APPLIED:
      return {
        ...state,
        user: { ...state.user, is_already_apply: action.payload },
      };
    case SHARED_REDUCER_ACTIONS.SAVE_UNREAD_NOTIFICATIONS_COUNT:
      return {
        ...state,
        unreadNotificationsCount: action.payload,
      };
    case SHARED_REDUCER_ACTIONS.SAVE_DECLARED_RESULT:
      return {
        ...state,
        declaredResult: action.payload,
      };
    default:
      return state;
  }
};

export default sharedReducer;
